import { StandNameKeys } from "@/pages/rollshop/models/Rollset";
import { Box, Tooltip } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import { rollsetStatus } from "../components/RollStatusInfo";
import { RollsetInfo, RollsetTableRow } from "../components/TableRollset";

export const useTableData = () => {
	const RollCellRenderer = (params: ICellRendererParams<RollsetTableRow>) => {
		const standName = params.colDef?.field! as StandNameKeys;
		const rollset: RollsetInfo = params.data![standName] as any;
		const letter = rollset.Letter;
		const status = rollsetStatus.find(
			(s) => s.code === rollset.RollsetStatusCode,
		);
		const topLocation = rollset.TopRollLocationKey;
		const bottomLocation = rollset.BottomRollLocationKey;

		return (
			<Tooltip title={status?.name ?? ""} arrow>
				<Box
					component="div"
					data-test-id={`rollset-cell-${standName}-${letter}`}
					sx={{
						fontWeight: "500",
						background: status?.color,
						color: status?.textColor || "#1F2937",
						margin: 0.25,
						marginTop: 0.5,
						marginBottom: 0.5,
						padding: 1,
						borderRadius: 1,
						height: "100%",
						width: "100%",
						display: "flex",
						flexDirection: "column",
						justifyContent: "space-around",
					}}
					data-state={status?.name}
				>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							height: 24,
							marginBottom: 5,
						}}
					>
						<div
							style={{
								flex: 1,
								minWidth: 0,
								width: 0,
								overflow: "hidden",
								display: "flex",
								flexDirection: "column",
								lineHeight: 1.15,
							}}
						>
							<div
								style={{
									whiteSpace: "nowrap",
									overflow: "hidden",
									textOverflow: "ellipsis",
									fontSize: 12,
								}}
								data-test-id="top-roll-name"
							>
								{rollset?.TopRollName || "-"}
							</div>
							<div
								style={{
									fontSize: 10,
									opacity: 0.75,
								}}
							>
								{parseFloat(rollset?.TopRollDiameter?.toFixed(3) || "0") || ""}
							</div>
						</div>
						<div
							style={{
								marginLeft: 4,
								whiteSpace: "nowrap",
								fontSize: 11,
								opacity: 0.8,
								width: 24,
								textAlign: "right",
							}}
						>
							{topLocation || " "}
						</div>
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							height: 24,
						}}
					>
						<div
							style={{
								flex: 1,
								minWidth: 0,
								width: 0,
								overflow: "hidden",
								display: "flex",
								flexDirection: "column",
								lineHeight: 1.15,
							}}
						>
							<div
								style={{
									whiteSpace: "nowrap",
									overflow: "hidden",
									textOverflow: "ellipsis",
									fontSize: 12,
								}}
								data-test-id="bottom-roll-name"
							>
								{rollset?.BottomRollName || "-"}
							</div>
							<div
								style={{
									fontSize: 10,
									opacity: 0.75,
								}}
							>
								{parseFloat(rollset?.BottomRollDiameter?.toFixed(3) || "0") ||
									""}
							</div>
						</div>
						<div
							style={{
								marginLeft: 4,
								whiteSpace: "nowrap",
								fontSize: 11,
								opacity: 0.8,
								width: 24,
								textAlign: "right",
							}}
						>
							{bottomLocation || " "}
						</div>
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "flex-end",
							alignItems: "center",
							height: 15,
						}}
					>
						<div
							style={{
								fontWeight: rollset.BottomRollId ? "600" : "300",
								fontSize: 13,
							}}
						>
							{letter || ""}
						</div>
					</div>
				</Box>
			</Tooltip>
		);
	};

	const cellStyle = { padding: "0" };
	const colConfig = {
		cellRenderer: RollCellRenderer,
		cellStyle: cellStyle,
	};
	const columnDefs = [
		{ field: "F1", headerName: "F1", ...colConfig },
		{ field: "F2", headerName: "F2", ...colConfig },
		{ field: "F3", headerName: "F3", ...colConfig },
		{ field: "F4", headerName: "F4", ...colConfig },
		{ field: "F5", headerName: "F5", ...colConfig },
		{ field: "F6", headerName: "F6", ...colConfig },
		{ field: "F7", headerName: "F7", ...colConfig },
		{ field: "R1", headerName: "R1", ...colConfig },
		{ field: "R2", headerName: "R2", ...colConfig },
		{ field: "R3", headerName: "R3", ...colConfig },
		{ field: "R4", headerName: "R4", ...colConfig },
	];
	return { columnDefs };
};
